export enum DeclarationType {
    Cargo = 'CargoDeclaration',
    CrewEffects = 'CrewEffectsDeclaration',
    CrewList = 'CrewListDeclaration',
    DangerousGoods = 'DangerousGoodsDeclaration',
    FreePratique = 'FreePratique',
    General = 'GeneralDeclaration',
    Health = 'HealthDeclaration',
    PassengerList = 'PassengerDeclaration',
    VehicleList = 'VehicleListDeclaration',
    Security = 'SecurityDeclaration',
    ShipsStore = 'ShipsDeclaration',
    VesselsDeparture = 'VesselsDeparture',
    Waste = 'WasteDeclaration'
}
